import { CloseOutlined, DownloadOutlined, SaveOutlined } from "@ant-design/icons";
import { Button, message, Modal, Table, Tag } from "antd";
import { FileList, RebateAndCogsData } from "../../data";
import { useState } from "react";
import { axiosInstance } from "../../utils/axiosInterceptor";
import * as XLSX from 'xlsx';

const AutomationExceptionFile = ({
  open,
  hide,
  fileType,
  selectedFileData,
  isLoading,
  getSelectedCogsData,
  getRebatFile,
  fileData,
  getAllUploadedFiles
}) => {
  const [pagination, setPagination] = useState(10);
  const [rebateApproveLoading, setApproveRebateLoading] = useState(false);
  const [cogsApproveLoading, setApproveCogsLoading] = useState(false)
  const [cogsRejectLoading, setCogsRejectLoading] = useState(false)
  const [rebateRejectLoading, setRebateRejectLoading] = useState(false)

  const columns = [
    {
      title: "ID",
      dataIndex: "Id",
      key: "Id",
    },
    {
      title: "File ID",
      dataIndex: "FileId",
      key: "FileId",
    },
    {
      title: "Customer Group",
      dataIndex: "customerGroup",
      key: "customerGroup",
    },
     {
      title: "name",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "account_number",
      dataIndex: "accountNumber",
      key: "accountNumber",
    },
    {
      title: "Account Name",
      dataIndex: "accountName",
      key: "accountName",
    },
    {
      title: "period",
      dataIndex: "period",
      key: "period",
    },
    {
      title: "rebate_types_id",
      dataIndex: "rebate_types_id",
      key: "rebate_types_id",
      align:"right"
    },
    {
      title: "group_id",
      dataIndex: "group_id",
      key: "group_id",
      align:"right"
    },
    {
      title: "group_class",
      dataIndex: "group_class",
      key: "group_class",
      align:"right"
    },
    //  {
    //   title: "Total Rebate Amount",
    //   dataIndex: "totalRebateamount",
    //   key: "totalRebateamount",
    // },
    {
      title: "total_spend",
      dataIndex: "sys_Total_Rx",
      key: "sys_Total_Rx",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Speciality",
      dataIndex: "sys_Specialty",
      key: "sys_Specialty",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "generic_spend",
      dataIndex: "sys_Generic_Rx",
      key: "sys_Generic_Rx",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "hiv_spend",
      dataIndex: "sys_Hiv",
      key: "sys_Hiv",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "total_grp_spend",
      dataIndex: "total_grp_spend",
      key: "total_grp_spend",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "generic_grp_spend",
      dataIndex: "generic_grp_spend",
      key: "generic_grp_spend",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "hiv_grp_spend",
      dataIndex: "hiv_grp_spend",
      key: "hiv_grp_spend",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "add_exclu_grp_spend",
      dataIndex: "add_exclu_grp_spend",
      key: "add_exclu_grp_spend",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "grp_gcr_pct",
      dataIndex: "grp_gcr_pct",
      key: "grp_gcr_pct",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "grp_scrubbed_gcr_pct",
      dataIndex: "grp_sgpr_pct",
      key: "grp_sgpr_pct",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "group_gpr_pct",
      dataIndex: "grp_gpr_pct",
      key: "grp_gpr_pct",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    // {
    //   title: "grp_gcr_pct",
    //   dataIndex: "grp_gcr_pct",
    //   key: "grp_gcr_pct",
    //   align:"right",
    //   render: (val) =>
    //     val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    // },
    // {
    //   title: "grp_gcr_pct",
    //   dataIndex: "grp_gcr_pct",
    //   key: "grp_gcr_pct",
    //   align:"right",
    //   render: (val) =>
    //     val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    // },


    {
      title: "MCK GCR %",
      dataIndex: "gcrPer",
      key: "gcrPer",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },

    {
      title: "MCK SGCR %",
      dataIndex: "sgcrPer",
      key: "sgcrPer",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },

    {
      title: "MCK GPR %",
      dataIndex: "gprPer",
      key: "gprPer",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "scrubbed_gcr %",
      dataIndex: "sys_SGCR_Percentage",
      key: "sys_SGCR_Percentage",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "gcr_pct %",
      dataIndex: "sys_GCR_Percentage",
      key: "sys_GCR_Percentage",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "account_gpr_pct %",
      dataIndex: "sys_GPR_Percentage",
      key: "sys_GPR_Percentage",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
     {
      title: "earned_gcr_generic %",
      dataIndex: "genericsgcrper",
      key: "genericsgcrper",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
     {
      title: "earned_gpr_generic %",
      dataIndex: "genericgprper",
      key: "genericgprper",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
     {
      title: "earned_total_generic",
       key: "earnedtotalgeneric",
       align:"right",
      render: (_, record) => {
        const gcr = Number(record?.genericgprper) || 0;
        const gpr = Number(record?.genericsgcrper) || 0;
        const total = gcr + gpr;
        return total ? total?.toFixed(2) : "-";
  },
    },
     {
      title: "earned_gcr_brand %",
      dataIndex: "brandsgcrper",
      align:"right",
      key: "brandsgcrper",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
     {
      title: "earned_gpr_brand %",
      dataIndex: "brandgprper",
      key: "brandgprper",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "earned_total_brand",
      key: "earnedtotalbrand",
      align:"right",
      render: (_, record) => {
        const gcr = Number(record?.brandsgcrper) || 0;
        const gpr = Number(record?.brandgprper) || 0;
        const total = gcr + gpr;
        return total ? total?.toFixed(2) : "-";
      },
    },
    {
      title: "Generic Var",
      key: "genericvar",
      align:"right",
      render: (_, record) => {
        const gcr = Number(record?.genericsgcrper) || 0;
        const gpr = Number(record?.genericgprper) || 0;
        const sysgcr = Number(record?.sys_generic_sgcr_per) || 0;
        const sysgpr = Number(record?.sys_generic_gpr_per) || 0;
        const total = ((gcr + gpr) - (sysgcr + sysgpr));
        return total ? total?.toFixed(2) : "-";
      },
    },
    {
      title: "Brand Var",
      key: "brandvar",
      align:"right",
      render: (_, record) => {
        const gcr = Number(record?.brandsgcrper) || 0;
        const gpr = Number(record?.brandgprper) || 0;
        const sysgcr = Number(record?.sys_brand_sgcr_per) || 0;
        const sysgpr = Number(record?.sys_brand_gpr_per) || 0;
        const total = ((gcr + gpr) - (sysgcr + sysgpr));
        return total ? total?.toFixed(2) : "-";
      },
    },
    
    {
      title: "Paid Generic Pct %",
      key: "paidGenericPct",
      align:"right",
      render: (_, record) => {
        const gcr = Number(record?.genericsgcrper) || 0;
        const gpr = Number(record?.genericgprper) || 0;
        const total = gcr + gpr;
        return total ? total?.toFixed(2) : "-";
     },
    },
    {
      title: "Paid Brand Pct %",
      key: "paidbrandgpr",
      align:"right",
      render: (_, record) => {
        const gcr = Number(record?.brandsgcrper) || 0;
        const gpr = Number(record?.brandgprper) || 0;
        const total = gcr + gpr;
        return total ? total?.toFixed(2) : "-";
  },
    },
     {
      title: "MCK Brand GCR Rebate %",
      dataIndex: "brandsgcrper",
      key: "brandsgcrper",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
     {
      title: "MCK Brand GPR Rebate %",
      dataIndex: "brandgprper",
      key: "brandgprper",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Generic GCR  %",
      dataIndex: "sys_generic_sgcr_per",
      key: "sys_generic_sgcr_per",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Generic GPR  %",
      dataIndex: "sys_generic_gpr_per",
      key: "sys_generic_gpr_per",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Brand GCR  %",
      dataIndex: "sys_brand_sgcr_per",
      key: "sys_brand_sgcr_per",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Brand GPR  %",
      dataIndex: "sys_brand_gpr_per",
      key: "sys_brand_gpr_per",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Generic GCR Amount",
      dataIndex: "eligiblegenericsgcr",
      key: "eligiblegenericsgcr",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "SYS Generic GPR Amount",
      dataIndex: "eligiblegenericgpr",
      key: "eligiblegenericgpr",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    }, {
      title: "SYS Brand GCR Amount",
      dataIndex: "eligiblebrandsgcr",
      key: "eligiblebrandsgcr",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    }, {
      title: "SYS Brand GPR Amount",
      dataIndex: "eligiblebrandgpr",
      key: "eligiblebrandgpr",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    }, {
      title: "MCK Generic GCR Amount",
      dataIndex: "earned_gcr_generic_file",
      key: "earned_gcr_generic_file",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    }, {
      title: "MCK Generic GPR Amount",
      dataIndex: "earned_gpr_generic_file",
      key: "earned_gpr_generic_file",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    }, {
      title: "MCK Brand GCR Amount",
      dataIndex: "earned_gcr_brand_file",
      key: "earned_gcr_brand_file",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    }, {
      title: "MCK Brand GPR Amount",
      dataIndex: "earned_gpr_brand_file",
      key: "earned_gpr_brand_file",
      align:"right",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title: "Exception Reason",
      dataIndex: "exceptionReason",
      key: "exceptionReason",
    },
    {
      title: "Action",
      dataIndex: "status",
      key: "status",
      render: (status, record) => {
        if (status === "Rejected") {
          return <Tag color="red">Rejected</Tag>;
        } else if (status === "Approved") {
          return <Tag color="green">Approved</Tag>;
        } else if (status === "Pending" || status === "Uploaded") {
          return (
            <div className="flex gap-2">
              <Button
                type="primary"
                size="small"
                loading={rebateApproveLoading === record.Id}
                onClick={() => handleApprove(record)}
              >
                Approve
              </Button>
              <Button
                danger
                size="small"
                loading={rebateRejectLoading === record.Id}
                onClick={() => handleReject(record)}
              >
                Reject
              </Button>
            </div>
          );
        } else {
          return <Tag color="default">{status || "Unknown"}</Tag>;
        }
      },
    }
  ];

  const cogsColumn = [
    {
      title: "File ID",
      dataIndex: "FileId",
      key: "FileId",
    },
    {
      title: "Primary Account",
      dataIndex: "PRIMARY_ACCT",
      key: "PRIMARY_ACCT",
    },
    
    {
      title: "Account Id",
      dataIndex: "ACCT_ID",
      key: "ACCT_ID",
    },
    {
      title: "Lock ID",
      dataIndex: "INA_LOC_ID",
      key: "INA_LOC_ID",
      render: (value) => value === null || value === undefined ? "null" : value
    },
    {
      title:"Store Name",
      dataIndex:"STORE_NAME",
      key:"STORE_NAME"
    },
    {
      title:"MCK RX Amount",
      dataIndex:"RX_AMT",
      key:"RX_AMT",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"MCK Generic RX Amount",
      dataIndex:"GRX_AMT",
      key:"GRX_AMT",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"MCK HIV Amount",
      dataIndex:"HIV_AMT",
      key:"HIV_AMT",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"MCK GCR %",
      dataIndex:"GCR",
      key:"GCR",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"Portal RX Amount",
      dataIndex:"Portal_RX",
      key:"Portal_RX",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"Portal Generic RX Amount",
      dataIndex:"Portal_GRX",
      key:"Portal_GRX",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },

    {
      title:"Portal HIV Amount",
      dataIndex:"Portal_HIV",
      key:"Portal_HIV",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"Portal GCR %",
      dataIndex:"Portal_GCR",
      key:"Portal_GCR",
      render: (val) =>
        val === undefined || val === "" || val === "null" ? "-" : val?.toFixed(2),
    },
    {
      title:"RX DIFF",
      dataIndex:"RX_DIFF",
      key:"RX_DIFF",
      render: (value) => <span className="cardtitle ">{value?.toFixed(2)}</span>
    },
    {
      title:"Generic RX DIFF",
      dataIndex:"GRX_DIFF",
      key:"GRX_DIFF",
      render: (value) => <span className="cardtitle ">{value?.toFixed(2)}</span>
    },
    {
      title:"GCR DIFF",
      dataIndex:"GCR_DIFF",
      key:"GCR_DIFF",
      render: (value) => <span className="cardtitle ">{value?.toFixed(2)}</span>
    },
    {
      title:"HIV DIFF",
      dataIndex:"HIV_DIFF",
      key:"HIV_DIFF",
      render: (value) => <span className="cardtitle ">{value?.toFixed(2)}</span>
    },
    {
      title:"Quarter Label",
      dataIndex:"QuarterLabel",
      key:"QuarterLabel",
    },
    {
      title: "Exception Reason",
      dataIndex: "ErrorReasons",
      key: "ErrorReasons",
    },
    {
      title: "Action",
      dataIndex: "Status",
      key: "action",
      render: (status, record) => {
        if (status === "Rejected") {
          return <Tag color="red">Rejected</Tag>;
        } else if (status === "Approved") {
          return <Tag color="green">Approved</Tag>;
        } else if (status === "Pending" || status === "Uploaded") {
          return (
            <div className="flex gap-2">
              <Button
                type="primary"
                size="small"
                onClick={() => handleApproveCogs(record)}
              >
                Approve
              </Button>
              <Button
                danger
                size="small"
                onClick={() => handleRejectCogs(record)}
              >
                Reject
              </Button>
            </div>
          );
        } else {
          return <Tag color="default">{status || "Unknown"}</Tag>;
        }
      },
    }

  ];

  const handleApproveCogs = async (record) => {
    if (!record?.FileId) {
      return;
    }
    try {
      const response = await axiosInstance.post(
        `/automationRouter/exceptionCOGS/${record?.FileId}/${record?.ACCT_ID}/approve`);
      getSelectedCogsData(record)
    } catch (error) {
      console.log(error, "erroror");
    } finally {
      console.log("");
      getAllUploadedFiles()
    }
  }
  const handleRejectCogs = async (record) => {
    if (!record?.FileId) {
      return;
    }
    const payload = {
      reason: record?.ErrorReasons
    }
    try {
      const response = await axiosInstance.post(
        `/automationRouter/exceptionCOGS/${record?.FileId}/${record?.ACCT_ID}/reject`, payload);
      getSelectedCogsData(record)
    } catch (error) {
      console.log(error, "erroror");
    } finally {
      console.log("");
      getAllUploadedFiles()
    }
  }

  const handleApprove = async (record) => {
    if (!record?.Id) {
      return;
    }
    setApproveRebateLoading(record.Id)
    const payload = {
      reason: record?.exceptionReason
    }
    try {
      const response = await axiosInstance.post(
        `/automationRouter/rebate-exceptions/approve/${record?.Id}`, payload);
      getRebatFile(record)
    } catch (error) {
      console.log(error, "erroror");
    } finally {
      console.log("");
      setApproveRebateLoading(false)
      getAllUploadedFiles()
    }
  }

  const handleExportCOgs = async () => {
    const exportData = selectedFileData;
    const headers = [
      "File ID",
      "Primary Account",
      "Account Id",
      "Lock ID",
      "Store Name",
      "MCK RX Amount",
      "MCK GRX Amount",
      "MCK HIV Amount",
      "MCK GCR %",
      "Portal RX Amount",
      "Portal Generic RX Amount",
      "Portal HIV Amount",
      "Portal GCR %",
      "RX DIFF",
      "GRX DIFF",
      "HIV DIFF",
      "GCR DIFF",
      // "Current BRX COG",
      // "BRX COG Base",
      // "Final COGs",
      // "Preliminary BRX COG",
      // "Base DSO",
      // "DSO",
      // "DSO ADJ",
      // "Pay Method",
      // "Pay Method ADJ",
      // "CUR BRX File",
      // "CUR BRX DB",
      // "COG File",
      // "COG DB",
      // "GCR File",
      // "GCR DB",
      "Exception Reason",
      // "Status"
    ];

    const rows = exportData.map((item) => [
      item?.FileId,
      item?.PRIMARY_ACCT,
      item?.ACCT_ID,
      // item?.LockID === null ? "null" : item?.LockID,
      item?.INA_LOC_ID === null ? "null" : item?.INA_LOC_ID,
      item?.STORE_NAME,
      item?.RX_AMT,
      item?.GRX_AMT,
      item?.HIV_AMT,
      item?.GCR,
      item?.Portal_RX,
      item?.Portal_GRX,
      item?.Portal_HIV,
      item?.Portal_GCR,
      item?.RX_DIFF,
      item?.GRX_DIFF,
      item?.HIV_DIFF,
      item?.GCR_DIFF,
      // item?.Current_BRX_COG,
      // item?.BRX_COG_BASE,
      // item?.Final_COGs,
      // item?.Preliminary_BRX_COG,
      // item?.BASE_DSO,
      // item?.DSO,
      // item?.DSO_ADJ,
      // item?.PAY_METHOD,
      // item?.PAY_METHOD_ADJ,
      // item?.CUR_BRX_File,
      // item?.CUR_BRX_DB,
      // item?.COG_File,
      // item?.COG_DB,
      // item?.GCR_File,
      // item?.GCR_DB,
      item?.ErrorReasons,
      // item?.Status
    ]);

    // Combine headers and data
    const worksheetData = [headers, ...rows];

    // Create worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "COGS file Report");

    // Export the Excel file
    const timestamp = new Date()
      .toISOString()
      .replace(/[:.]/g, "-");
    XLSX.writeFile(workbook, `COGSExceptions_${timestamp}.xlsx`);
  };

  const handleReject = async (record) => {
    if (!record?.Id) {
      return;
    }
    setRebateRejectLoading(record?.Id)
    const payload = {
      reason: record?.exceptionReason
    }
    try {
      const response = await axiosInstance.post(
        `/automationRouter/rebate-exceptions/reject/${record?.Id}`, payload);
      getRebatFile(record)
    } catch (error) {
      console.log(error, "erroror");
    } finally {
      console.log("");
      setRebateRejectLoading(false)
      getAllUploadedFiles()
    }
  }

  // const handleExportRebate = async () => {
  //       const exportData = selectedFileData;
  //       const headers = [
  //         "Account Number",
  //         "Account Name",
  //         "GCR Ratio",
  //         "SGCR Ratio",
  //         "GPR Ratio",
  //         "Eligible Generic SGCR",
  //         "Eligible Generic GPR",
  //         "Eligible Brand SGCR",
  //         "Eligible Brand GPR",
  //         "Earned GCR Generic File",
  //         "Earned GPR Generic File",
  //         "Earned GCR Brand File",
  //         "Earned GPR Brand File",
  //         "Exception Reason",
  //         "Status"
  //       ];

  //       const rows = exportData.map((item) => [
  //         item?.accountNumber,
  //         item?.accountName,
  //         item?.gcrPer,
  //         item?.sgcrPer,
  //         item?.gprPer,
  //         item?.eligiblegenericsgcr,
  //         item?.eligiblegenericgpr,
  //         item?.eligiblebrandsgcr,
  //         item?.eligiblebrandgpr,
  //         item?.earned_gcr_generic_file,
  //         item?.earned_gpr_generic_file,
  //         item?.earned_gcr_brand_file,
  //         item?.earned_gpr_brand_file,
  //         item?.exceptionReason,
  //         item?.status
  //       ]);

  //       // Combine headers and data
  //       const worksheetData = [headers, ...rows];

  //       // Create worksheet and workbook
  //       const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  //       const workbook = XLSX.utils.book_new();
  //       XLSX.utils.book_append_sheet(workbook, worksheet, "Rebate file Report");

  //       // Export the Excel file
  //       const timestamp = new Date()
  //         .toISOString()
  //         .replace(/[:.]/g, "-");  
  //       XLSX.writeFile(workbook, `RebateExceptions_${timestamp}.xlsx`);
  //   };

  const handleExportRebate = async () => {
    const exportData = selectedFileData;

    const headers = [
      "Id",
      "File ID",
      "customer Group",
      "Name",
      "account_number",
      "Account Name",
      "Email",
      "period",
      "rebate_types_id",
      "group_id",
      "group_class",
      "total_spend",
      "SYS Speciality",
      "generic_spend",
      "hiv_spend",
      "total_grp_spend",
      "generic_grp_spend",
      "hiv_grp_spend",
      "add_exclu_grp_spend",
      "grp_gcr_pct",
      "grp_scrubbed_gcr_pct",
      "group_gpr_pct",
      "MCK GCR %",
      "MCK SGCR %",
      "MCK GPR %",
      "scrubbed_gcr %",
      "gcr_pct %",
      "account_gpr_pct %",
      "earned_gcr_generic %",
      "earned_gpr_generic %",
      "earned_total_generic",
      "earned_gcr_brand %",
      "earned_gpr_brand %",
      "earned_total_brand",
      "Generic Var",
      "Brand Var",
      "Paid Generic Pct %",
      "Paid Brand Pct %",
      "MCK Brand GCR Rebate %",
      "MCK Brand GPR Rebate %",
      "SYS Generic GCR %",
      "SYS Generic GPR %",
      "SYS Brand GCR %",
      "SYS Brand GPR %",
      "SYS Generic GCR Amount",
      "SYS Generic GPR Amount",
      "SYS Brand GCR Amount",
      "SYS Brand GPR Amount",
      "MCK Generic GCR Amount",
      "MCK Generic GPR Amount",
      "MCK Brand GCR Amount",
      "MCK Brand GPR Amount",
      "Exception Reason",
    ];

    const rows = exportData.map((item) => [
      item?.Id,
      item?.FileId,
      item?.customerGroup,
      item?.customerName,
      item?.accountNumber,
      item?.accountName,
      item?.email,
      item?.period,
      item?.rebate_types_id,
      item?.group_id,
      item?.group_class,
      // item?.totalRebateamount,
      item?.sys_Total_Rx,
      item?.sys_Specialty,
      item?.sys_Generic_Rx,
      item?.sys_Hiv,
      item?.total_grp_spend,
      item?.generic_grp_spend,
      item?.hiv_grp_spend,
      item?.add_exclu_grp_spend,
      item?.grp_gcr_pct,
      item?.grp_sgpr_pct,
      item?.grp_gpr_pct,
      item?.gcrPer,
      item?.sgcrPer,
      item?.gprPer,
      item?.sys_SGCR_Percentage,
      item?.sys_GCR_Percentage,
      item?.sys_GPR_Percentage,
      item?.genericsgcrper,
      item?.genericgprper,
      item?.genericgprper + item?.genericsgcrper,
      item?.brandsgcrper,
      item?.brandgprper,
      item?.brandsgcrper + item?.brandgprper,
      ((item?.genericsgcrper + item?.genericgprper) - (item?.sys_generic_sgcr_per + item?.sys_generic_gpr_per)),
      ((item?.brandsgcrper + item?.brandgprper) - (item?.sys_brand_sgcr_per + item?.sys_brand_gpr_per)),
      item?.genericsgcrper + item?.genericgprper,
      item?.brandsgcrper + item?.brandgprper,
      item?.brandsgcrper,
      item?.brandgprper,
      item?.sys_generic_sgcr_per,
      item?.sys_generic_gpr_per,
      item?.sys_brand_sgcr_per,
      item?.sys_brand_gpr_per,
      item?.eligiblegenericsgcr,
      item?.eligiblegenericgpr,
      item?.eligiblebrandsgcr,
      item?.eligiblebrandgpr,
      item?.earned_gcr_generic_file,
      item?.earned_gpr_generic_file,
      item?.earned_gcr_brand_file,
      item?.earned_gpr_brand_file,
      item?.exceptionReason
    ]);

    const worksheetData = [headers, ...rows];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Rebate Comparison");

    const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
    XLSX.writeFile(workbook, `RebateExceptions_${timestamp}.xlsx`);
  };

  return (
    <Modal
      style={{ marginTop: "-60px" }}
      title={
        <div
          style={{
            borderBottom: "1px solid #f0f0f0",
            padding: "16px 24px",
            marginLeft: -24,
            marginRight: -24,
            marginTop: -16,
            fontSize: "16px",
            fontWeight: 500,
            color: "#262626",
            display: "flex",
            alignItems: "center",
          }}
        >
          Audit Comparison
        </div>
      }
      open={open}
      onCancel={hide}
      width="80%"
      destroyOnClose={true}
      maskClosable={false}
      keyboard={false}
      className="user-modal"
      closeIcon={<CloseOutlined />}
      footer={
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
            borderTop: "1px solid #f0f0f0",
            padding: "16px 0",
            marginTop: "24px",
          }}
        ></div>
      }
      styles={{
        padding: "24px",
        maxHeight: "80vh",
        overflowY: "auto",
      }}
    >
      <div className="flex justify-between items-center mt-3">
        <div>
          <span className="cardtitle ">{fileData?.FileName}</span>
        </div>
        {
          (fileType === "Rebate" || fileType === "COGS") && (
            <div>
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={() => {
                  fileType === "Rebate" ?
                    handleExportRebate()
                    : handleExportCOgs()
                }
                }
                className="w-[100px] ml-4"
              >
                Export
              </Button>

            </div>
          )
        }
      </div>
      <div style={{ marginTop: "24px" }}>
        <Table
          columns={fileType === "COGS" ? cogsColumn : columns}
          dataSource={selectedFileData}
          scroll={{ x: "max-content" }}
          rowKey="id"
          size="middle"
          loading={isLoading}
          className="custom-table user-tbl"
          pagination={{
            pageSize: pagination,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} accounts`,
            onShowSizeChange: (current, size) => {
              setPagination(size);
            },
          }}
        />
      </div>
      <style>
        {`.custom-country-dropdown {
          width: 220px !important; 
          }
          .remove-caret .ant-select-selection-search input {
  caret-color: transparent !important;
  // color: transparent !important;     
  background-color: transparent;       
}     
`}
      </style>
    </Modal>
  );
};

export default AutomationExceptionFile;